class Filename {
  
  /** Sanitize a filename: 
   * - lowercases
   * - removes diacritics (accents)
   * - replaces spaces with -
   * - removes all characters not allowed in filenames
   * - collapses repeated -
   * - trims leading/trailing -
  */
  static sanitize(name: string): string {
    return name
      .normalize("NFD")                     // split accents
      .replace(/[\u0300-\u036f]/g, "")      // remove diacritic marks
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")          // anything not alphanumeric → hyphen
      .replace(/-+/g, "-")                  // collapse multiple hyphens
      .replace(/^-+|-+$/g, "");             // trim hyphens from ends
  }  
}

export { Filename }
